module.exports = __webpack_public_path__ + "img/visa.997dd970.svg";